import { render, staticRenderFns } from "./TopicDetail.vue?vue&type=template&id=4d4143ca&scoped=true&"
import script from "./TopicDetail.vue?vue&type=script&lang=js&"
export * from "./TopicDetail.vue?vue&type=script&lang=js&"
import style0 from "./TopicDetail.vue?vue&type=style&index=0&id=4d4143ca&lang=less&scoped=true&"
import style1 from "./TopicDetail.vue?vue&type=style&index=1&lang=css&"
import style2 from "./TopicDetail.vue?vue&type=style&index=2&id=4d4143ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d4143ca",
  null
  
)

export default component.exports